import { getListTransform } from 'helpers/transformResponse';
import type from './types';

const INITIAL_STATE = {
  list: {
    content: [],
  },
  listTemplates: {
    content: [],
  },
  detail: {},
  loading: false,
  loadingTemplates: false,
  buttonLoading: false,
};

/**
 * @param {Object} state - Default application state
 * @param {Object} action - Action from action creator
 * @returns {Object} New state
 */
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case type.CUPOM_FETCHED:
      return {
        ...state,
        list: getListTransform(action.payload.data) || INITIAL_STATE.list,
        loading: false,
      };
    case type.CUPOM_DETAIL:
      return {
        ...state,
        detail: action.payload,
        loading: false,
      };
    case type.CUPOM_LOAD:
      return {
        ...state,
        loading: action.payload,
      };
    case type.CUPOM_TEMPLATES_FETCHED:
      return {
        ...state,
        listTemplates:
          getListTransform(action.payload.data) || INITIAL_STATE.listTemplates,
        loadingTemplates: false,
      };
    case type.CUPOM_TEMPLATES_LOAD:
      return {
        ...state,
        loadingTemplates: action.payload,
      };
    case type.CUPOM_BUTTON_LOAD:
      return {
        ...state,
        buttonLoading: action.payload,
      };

    default:
      return state;
  }
};
